import React from "react";

export default function RestaurantDetails(restaurant: Contracts.DBRestaurantShape) {
    return (
        <div style={{ margin: 16 }}>
            <pre>{JSON.stringify(restaurant, null, 2)}</pre>
        </div>
    );
}
